// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 200) return "static/chunks/200-c6459c74b79c683d.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"b0ecaadfda131799","172":"8b89834f0ec3f162","777":"4fcfd431ec9e77cd"}[chunkId] + ".js";
};